import React from 'react';
import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
export function InstagramSection() {
  return <section className="py-24 px-6 bg-stone-50 overflow-hidden" data-id="element-62">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12 lg:gap-24" data-id="element-63">
        <motion.div className="w-full md:w-1/2" initial={{
        opacity: 0,
        x: -50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-64">
          <div className="relative max-w-sm mx-auto" data-id="element-65">
            {/* Decorative background blob */}
            <div className="absolute -inset-4 bg-brand-blush rounded-[3rem] rotate-6 opacity-50" data-id="element-66"></div>

            {/* Phone-like frame */}
            <div className="relative bg-white p-3 rounded-[2.5rem] shadow-2xl border border-stone-100" data-id="element-67">
              <div className="overflow-hidden rounded-[2rem] bg-stone-100" data-id="element-68">
                <img src="https://cdn.magicpatterns.com/uploads/oqfxJ3AttC3HbW8JDEaHzY/WhatsApp_Image_2026-04-15_at_21.57.55.jpg" alt="Instagram de Dulce Despertar PUQ" className="w-full h-auto" data-id="element-69" />
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div className="w-full md:w-1/2 text-center md:text-left space-y-6" initial={{
        opacity: 0,
        x: 50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-70">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-tr from-yellow-400 via-rose-500 to-purple-600 text-white mb-2" data-id="element-71">
            <Instagram className="w-8 h-8" data-id="element-72" />
          </div>
          <h2 className="text-4xl md:text-5xl font-serif text-brand-dark" data-id="element-73">
            Síguenos en Instagram
          </h2>
          <p className="text-lg text-stone-600 text-balance" data-id="element-74">
            Únete a nuestra comunidad y descubre más sorpresas, nuevos productos
            y momentos especiales que compartimos día a día.
          </p>
          <div className="pt-4" data-id="element-75">
            <a href="https://instagram.com/dulce.despertarpuq" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-6 py-3 border-2 border-stone-800 text-stone-800 font-medium rounded-full hover:bg-stone-800 hover:text-white transition-colors duration-300" data-id="element-76">
              @dulce.despertarpuq
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}